(function () {
  'use strict';

  var ADDED_MS = 1400;
  var ERROR_MS = 1800;

  function routes() {
    var r = window.Theme && window.Theme.routes ? window.Theme.routes : {};
    return {
      add: r.cart_add_url || '/cart/add.js',
      cart: r.cart_url || '/cart',
      change: r.cart_change_url || '/cart/change.js',
      checkout: (r.root_url || '/') + 'checkout',
    };
  }

  function formatMoney(cents) {
    return (Number(cents || 0) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var cartUi = null;

  function initCartUi() {
    if (cartUi) return cartUi;

    var root = document.querySelector('[data-artemest-cart]');
    if (!root) return null;

    var bodyEl = root.querySelector('[data-artemest-cart-body]');
    var footEl = root.querySelector('[data-artemest-cart-foot]');
    var countEl = root.querySelector('[data-artemest-cart-count]');
    var subtotalEl = root.querySelector('[data-artemest-cart-subtotal]');
    var checkoutEl = root.querySelector('[data-artemest-cart-checkout]');
    var cartJsonUrl = root.dataset.cartJsUrl || routes().cart + '.js';
    var cartChangeUrl = root.dataset.cartChangeUrl || routes().change;
    var checkoutUrl = root.dataset.checkoutUrl || routes().checkout;

    function open() {
      root.hidden = false;
      requestAnimationFrame(function () {
        root.classList.add('is-open');
      });
      document.body.classList.add('artemest-cart-open');
    }

    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('artemest-cart-open');
      window.setTimeout(function () {
        if (!root.classList.contains('is-open')) root.hidden = true;
      }, 340);
    }

    function updateHeaderCount(count) {
      document.querySelectorAll('.artemest-header__cart-count').forEach(function (el) {
        el.remove();
      });
      var cartLink = document.querySelector('.artemest-header__cart');
      if (!cartLink || count <= 0) return;
      var badge = document.createElement('span');
      badge.className = 'artemest-header__cart-count';
      badge.textContent = String(count);
      cartLink.appendChild(badge);
    }

    function changeLine(key, quantity) {
      return fetch(cartChangeUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity }),
      }).then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || payload.status) {
            throw new Error(payload.description || payload.message || 'Failed to update cart');
          }
          return payload;
        });
      });
    }

    function bindCartItemActions() {
      if (!bodyEl) return;

      bodyEl.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var itemEl = btn.closest('[data-line-key]');
          if (!itemEl) return;
          var key = itemEl.getAttribute('data-line-key');
          if (!key) return;

          var qtySpan = itemEl.querySelector('.artemest-cart__qty span');
          var currentQty = parseInt((qtySpan && qtySpan.textContent) || '1', 10);
          var delta = parseInt(btn.getAttribute('data-qty-change') || '0', 10);
          var nextQty = Math.max(0, currentQty + delta);

          changeLine(key, nextQty)
            .then(function () {
              return fetchCart();
            })
            .then(function (cart) {
              render(cart);
            })
            .catch(function (error) {
              console.error('[artemest-atc]', error);
            });
        });
      });

      bodyEl.querySelectorAll('[data-remove-line]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var itemEl = btn.closest('[data-line-key]');
          if (!itemEl) return;
          var key = itemEl.getAttribute('data-line-key');
          if (!key) return;

          changeLine(key, 0)
            .then(function () {
              return fetchCart();
            })
            .then(function (cart) {
              render(cart);
            })
            .catch(function (error) {
              console.error('[artemest-atc]', error);
            });
        });
      });
    }

    function render(cart) {
      var count = cart.item_count || 0;
      if (countEl) countEl.textContent = count > 0 ? '(' + count + ')' : '';
      updateHeaderCount(count);

      if (!count) {
        if (footEl) footEl.hidden = true;
        if (bodyEl) {
          bodyEl.innerHTML =
            '<div class="artemest-cart__empty">' +
            '<h3 class="artemest-cart__empty-title">Your bag is empty</h3>' +
            '<p class="artemest-cart__empty-text">Discover handcrafted crystal art and curated pieces for your home.</p>' +
            '<button type="button" class="artemest-btn artemest-btn--outline" data-artemest-cart-close>Continue Shopping</button>' +
            '</div>';
          bodyEl.querySelector('[data-artemest-cart-close]')?.addEventListener('click', close);
        }
        return;
      }

      if (footEl) footEl.hidden = false;
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (checkoutEl) checkoutEl.href = checkoutUrl;

      if (!bodyEl) return;

      bodyEl.innerHTML =
        '<div class="artemest-cart__items">' +
        cart.items
          .map(function (item) {
            return (
              '<article class="artemest-cart__item" data-line-key="' +
              escapeHtml(item.key) +
              '">' +
              '<a href="' +
              escapeHtml(item.url) +
              '" class="artemest-cart__item-media">' +
              (item.image
                ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
                : '') +
              '</a>' +
              '<div class="artemest-cart__item-info">' +
              '<p class="artemest-cart__item-vendor">' +
              escapeHtml(item.vendor) +
              '</p>' +
              '<h3 class="artemest-cart__item-title"><a href="' +
              escapeHtml(item.url) +
              '">' +
              escapeHtml(item.product_title) +
              '</a></h3>' +
              (item.variant_title && item.variant_title !== 'Default Title'
                ? '<p class="artemest-cart__item-variant">' + escapeHtml(item.variant_title) + '</p>'
                : '') +
              '<p class="artemest-cart__item-price">' +
              formatMoney(item.final_line_price) +
              '</p>' +
              '<div class="artemest-cart__item-actions">' +
              '<div class="artemest-cart__qty">' +
              '<button type="button" data-qty-change="-1" aria-label="Decrease quantity"' +
              (item.quantity <= 1 ? ' disabled' : '') +
              '>−</button>' +
              '<span>' +
              item.quantity +
              '</span>' +
              '<button type="button" data-qty-change="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="artemest-cart__remove" data-remove-line>Remove</button>' +
              '</div>' +
              '</div>' +
              '</article>'
            );
          })
          .join('') +
        '</div>';

      bindCartItemActions();
    }

    function fetchCart() {
      return fetch(cartJsonUrl, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart fetch failed');
        return response.json();
      });
    }

    root.querySelectorAll('[data-artemest-cart-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    cartUi = { open: open, close: close, render: render, fetchCart: fetchCart };
    return cartUi;
  }

  function postAdd(variantId, quantity) {
    var cfg = routes();
    var body = JSON.stringify({
      items: [{ id: Number(variantId), quantity: quantity }],
    });

    return fetch(cfg.add, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: body,
    }).then(function (response) {
      return response.text().then(function (text) {
        var data;
        try {
          data = JSON.parse(text);
        } catch (error) {
          throw new Error('Invalid response from cart');
        }
        if (data.status) {
          throw new Error(data.description || data.message || 'Unable to add to cart');
        }
        return data;
      });
    });
  }

  function addAndOpen(variantId, quantity) {
    return postAdd(variantId, quantity).then(function () {
      var ui = initCartUi();
      if (!ui) throw new Error('Cart drawer missing');

      return ui.fetchCart().then(function (cart) {
        ui.render(cart);
        ui.open();
        return cart;
      });
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('[data-artemest-atc]');
      if (!btn) return;

      var form = btn.closest('#artemest-product-form');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();

      if (btn.dataset.artemestAdding === 'true') return;

      var variantInput = form.querySelector('#artemest-variant-id');
      var variantId =
        (variantInput && variantInput.value) ||
        btn.getAttribute('data-variant-id') ||
        btn.dataset.variantId;

      if (!variantId) return;

      var qtyInput = form.querySelector('[name="quantity"]');
      var quantity = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10));
      var originalText = btn.textContent || 'Add to Cart';

      btn.dataset.artemestAdding = 'true';
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';

      addAndOpen(variantId, quantity)
        .then(function () {
          btn.textContent = 'Added';
          window.setTimeout(function () {
            btn.textContent = originalText;
          }, ADDED_MS);
        })
        .catch(function (error) {
          console.error('[artemest-atc]', error);
          btn.textContent = 'Try Again';
          window.setTimeout(function () {
            btn.textContent = originalText;
          }, ERROR_MS);
        })
        .finally(function () {
          btn.classList.remove('is-loading');
          delete btn.dataset.artemestAdding;
        });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-artemest-open-cart]');
      if (!trigger) return;
      event.preventDefault();

      var ui = initCartUi();
      if (!ui) return;

      ui.fetchCart()
        .then(function (cart) {
          ui.render(cart);
          ui.open();
        })
        .catch(function () {
          ui.open();
        });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartUi);
  } else {
    initCartUi();
  }
})();
